import { FUNCTIONAL_ELEMENT_TYPE, FunctionalElement } from './functional-element';

export type WorkstepsPerformed = Readonly<{
    // WORKSTEPS_PERFORMED never has a controlling checkpoint, since it functions as a controlling element itself
    controllingCheckpoint: '';
    type: FUNCTIONAL_ELEMENT_TYPE.WORKSTEPS_PERFORMED;
}> &
    FunctionalElement;

export const initialWorkstepsPerformed: WorkstepsPerformed = {
    contentLoadedFromXml: false,
    controllingCheckpoint: '',
    disabled: false,
    id: -1,
    parentId: -1,
    type: FUNCTIONAL_ELEMENT_TYPE.WORKSTEPS_PERFORMED,
    controllingOption: undefined,
};

export function isWorkstepsPerformed(f: FunctionalElement): f is WorkstepsPerformed {
    return f.type === FUNCTIONAL_ELEMENT_TYPE.WORKSTEPS_PERFORMED;
}
